/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";

import { ModalDropdownMenuHeader } from "../../../../../components/_base/modals/ModalDropdownMenuHeader/ModalDropdownMenuHeader.emotion";
import { ModalTabContent } from "../../../../../components/_base/modals/ModalTabContent/ModalTabContent.emotion";
import { SelectGuideContent } from "./SelectGuideContent.emotion";

export const SelectGuideTabContent = () => {
  const t = useTranslations();

  return (
    <ModalTabContent
      value={"guideSelectMenu"}
      key={"guideSelectMenu"}
      header={
        <ModalDropdownMenuHeader>
          {t("track_settings_guide")}
        </ModalDropdownMenuHeader>
      }
    >
      <SelectGuideContent />
    </ModalTabContent>
  );
};
